import _assign from "object-assign";
import { useContext, useCallback, useEffect, useMemo, useRef } from 'react';
import warning from 'warning';
import debounce from 'debounce';
import { ARIA_ANNOUNCER } from './custom-elements/constants';
import { dispatchAnnouncementEvent } from './custom-elements/dispatchAnnouncementEvent';
import AriaAnnouncerContext from './AriaAnnouncerContext';

var useAriaAnnouncer = function useAriaAnnouncer() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$debounce = _ref.debounce,
      debounceInterval = _ref$debounce === void 0 ? 0 : _ref$debounce;

  var context = useContext(AriaAnnouncerContext);
  var mountedRef = useRef(true);
  var baseAnnounce = useCallback(function (announcement, delay) {
    var isReactAnnouncerInstalled = context && context.announce;
    var isCustomEementAnnouncerInstalled = typeof customElements !== 'undefined' && customElements.get(ARIA_ANNOUNCER);
    warning(isReactAnnouncerInstalled || isCustomEementAnnouncerInstalled, 'useAriaAnnouncer is being used without an AriaAnnouncerProvider. Your application should be wrapped in an AriaAnnouncerProvider');

    function makeAnnouncement() {
      if (mountedRef.current) {
        if (isReactAnnouncerInstalled) {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          context.announce(announcement);
        } else {
          dispatchAnnouncementEvent(announcement);
        }
      }
    }

    if (delay) {
      setTimeout(makeAnnouncement, delay);
    } else {
      makeAnnouncement();
    }
  }, [context]);
  var announce = useMemo(function () {
    return debounceInterval > 0 ? debounce(baseAnnounce, debounceInterval) : baseAnnounce;
  }, [baseAnnounce, debounceInterval]);
  var ariaAnnouncer = useMemo(function () {
    return _assign({}, context, {
      announce: announce
    });
  }, [context, announce]);
  useEffect(function () {
    return function () {
      mountedRef.current = false;
    };
  }, []);
  return ariaAnnouncer;
};

export default useAriaAnnouncer;